import React from 'react'

export default function SchoolIcon() {
    return (
        <svg
          
            xmlns="http://www.w3.org/2000/svg"
            enableBackground="new 0 0 512 512"
            viewBox="0 0 58 58"
        >
            <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
                <g fillRule="nonzero">
                    <path
                        fill="#86b4cc"
                        d="M57 29v26H39V27zM19 27v28H1V29z"
                        data-original="#86b4cc"
                    ></path>
                    <path
                        fill="#a1c8d3"
                        d="M17 27h24v28H17z"
                        data-original="#a1c8d3"
                    ></path>
                    <path
                        fill="#567580"
                        d="M26 40h6a1 1 0 011 1v12h-8V41a1 1 0 011-1z"
                        data-original="#567580"
                    ></path>
                    <g fill="#464f5e">
                        <path
                            d="M26 36a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM12 37a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM6 37a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM12 43a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM6 43a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM12 49a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM6 49a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM52 37a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM46 37a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM52 43a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM46 43a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM52 49a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM46 49a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1zM32 36a1 1 0 01-1-1v-2a1 1 0 012 0v2a1 1 0 01-1 1z"
                            data-original="#464f5e"
                        ></path>
                    </g>
                    <path
                        fill="#edc100"
                        d="M57 53H1a1 1 0 00-1 1v2a1 1 0 001 1h14a1 1 0 001 1h26a1 1 0 001-1h14a1 1 0 001-1v-2a1 1 0 00-1-1z"
                        data-original="#edc100"
                    ></path>
                    <path
                        fill="#f8e8ab"
                        d="M43 53v4a1 1 0 01-1 1H16a1 1 0 01-1-1v-4z"
                        data-original="#f8e8ab"
                    ></path>
                    <path
                        fill="#393f4b"
                        d="M38 4.62V17H20V4.62l8.75 3.472a.728.728 0 00.5 0z"
                        data-original="#393f4b"
                    ></path>
                    <path
                        fill="#4397d5"
                        d="M54.55 24.11A2 2 0 0052.76 23H45v-2l-5.41-5.41a2.006 2.006 0 00-1.42-.59H18.94a1.985 1.985 0 00-1.54.72L13 21v2H5.24a2 2 0 00-1.79 1.11L1 29h56z"
                        data-original="#4397d5"
                    ></path>
                    <path
                        fill="#2b5781"
                        d="M45 21v3a1 1 0 01-1 1H14a1 1 0 01-1-1v-3z"
                        data-original="#2b5781"
                    ></path>
                    <path
                        fill="#3180bc"
                        d="M15 25h28v4H15z"
                        data-original="#3180bc"
                    ></path>
                    <path
                        fill="#464f5e"
                        d="M43 4.5a.971.971 0 01-.74.97L41 5.81l-3 .81-8.75 2.35c-.164.04-.336.04-.5 0L20 6.62l-4.26-1.15a1 1 0 010-1.94L28.75.03c.164-.04.336-.04.5 0L41 3.19l1.26.34a.971.971 0 01.74.97z"
                        data-original="#464f5e"
                    ></path>
                    <path
                        fill="#edc100"
                        d="M43.75 11.55a1 1 0 01-.83.45.939.939 0 01-.55-.17A3.047 3.047 0 0141 9.28V5.81l1.26-.34A.971.971 0 0043 4.5v4.78c0 .359.18.693.48.89a.987.987 0 01.27 1.38z"
                        data-original="#edc100"
                    ></path>
                </g>
            </g>
        </svg>
    )
}
